import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface ComboBoxProps extends KendoWidgetProps, kendo.ui.ComboBoxOptions {
    children?: React.ReactNode;
}

export default class ComboBox extends KendoBaseComponent<ComboBoxProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.ComboBox(domNode as Element, (props as kendo.ui.ComboBoxOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, dataSource, ...props } = this.props;

            this.widgetInstance.setOptions(props);
            const widget = (this.widgetInstance as kendo.ui.ComboBox);

            if (widget.options.dataSource !== dataSource) {
                widget.setDataSource(dataSource);
            }
            widget.value(this.props.value as string);
        }

        const domChild = React.Children
            .toArray(this.props.children)
            .filter((child: React.ReactElement<any>) => child && (child.type === 'input'))
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <input ref={this.elementRef} />;
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-react-wrapper/src/combobox/index.tsx